import React from 'react'
import { useLocation } from 'react-router-dom';
import styled from 'styled-components'
import { getMenu } from '../../redux/feature/menuSlice';
import { useEffect, useState} from 'react';
import { useDispatch ,useSelector} from 'react-redux';
import MenuCard from '../MenuCard';
import Loader from '../Loader';
import {b} from '../../styles/variables'
import {CloseOutline as Close} from '@styled-icons/evaicons-outline/CloseOutline'
import { ROLES } from '../FoodAppConstants'
import { updateFoodApi } from '../../api/allAxios'
import { toast } from 'react-hot-toast'

function Menu(props) {
  const location = useLocation()
  const url = props.url  
  const params=(location.pathname.split("/"))
  const dispatch=useDispatch()
  const menuState = useSelector((state)=>state.menu)
  const menu = menuState.menu
  const fetchingData = menuState.fetchingData
  const auth = useSelector((state) => state.auth)
  const menus = Object.values(menu)
  
  // Check if user is admin
  const isAdmin = auth?.creds?.roleslist?.includes(ROLES['Admin'])
  
  // Modal state
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [selectedFoodItem, setSelectedFoodItem] = useState(null)
  const [editFormData, setEditFormData] = useState({
    food_name: '',
    food_description: '',
    food_price: '',
    food_source: 'VEG'
  })
  const [isUpdating, setIsUpdating] = useState(false)

  const mainURL =params.length===4? url+ "/"+ params[3]:url
  
  useEffect(() => {     
    dispatch(getMenu(mainURL))    
  }, [mainURL, dispatch]);

  const handleEditClick = (foodItem) => {
    setSelectedFoodItem(foodItem)
    setEditFormData({
      food_name: foodItem?.food_name || '',
      food_description: foodItem?.food_description || '',
      food_price: foodItem?.food_price || '',
      food_source: foodItem?.food_source || 'VEG'
    })
    setIsEditModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsEditModalOpen(false)
    setSelectedFoodItem(null)
    setEditFormData({
      food_name: '',
      food_description: '',
      food_price: '',
      food_source: 'VEG'
    })
    setIsUpdating(false)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSaveChanges = async () => {
    if (!selectedFoodItem?.food_id) {
      toast.error('Food item ID not found')
      return
    }

    setIsUpdating(true)
    try {
      const response = await updateFoodApi(selectedFoodItem.food_id, editFormData)
      
      if (response.status === 200) {
        toast.success('Food item updated successfully!')
        // Refresh the menu data
        dispatch(getMenu(mainURL))
        handleCloseModal()
      } else {
        toast.error('Failed to update food item')
      }
    } catch (error) {
      console.error('Error updating food item:', error)
      toast.error(error.response?.data?.message || 'Failed to update food item')
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <MainContainer>
      { fetchingData ? <Loader/> : 
      <WrapperContainer>
      {
      menus.length ===0 ? <><b>No Food Items to display</b></> : <>
      <HeaderContainer>
 
      </HeaderContainer>
 <CardsContainer>
 {menus.map((menu,index )=> {
   return( <React.Fragment key={index} >
     <MenuCard 
       menu={menu} 
       id={index} 
       params={params} 
       onEditClick={handleEditClick}
       isAdmin={isAdmin}
     />
   </React.Fragment>
) })}
</CardsContainer>
</>
}
</WrapperContainer>
}

      {/* Edit Modal - Only show if admin */}
      {isAdmin && isEditModalOpen && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h2>Edit Food Item</h2>
              <CloseButton onClick={handleCloseModal}>
                <Close size={20} />
              </CloseButton>
            </ModalHeader>
            
            <ModalBody>
              <FormGroup>
                <Label>Food Name</Label>
                <Input
                  type="text"
                  name="food_name"
                  value={editFormData.food_name}
                  onChange={handleInputChange}
                  placeholder="Enter food name"
                />
              </FormGroup>
              
              <FormGroup>
                <Label>Description</Label>
                <Textarea
                  name="food_description"
                  value={editFormData.food_description}
                  onChange={handleInputChange}
                  placeholder="Enter food description"
                  rows="3"
                />
              </FormGroup>
              
              <FormGroup>
                <Label>Price</Label>
                <Input
                  type="number"
                  name="food_price"
                  value={editFormData.food_price}
                  onChange={handleInputChange}
                  placeholder="Enter price"
                  step="0.01"
                />
              </FormGroup>
              
              <FormGroup>
                <Label>Food Source</Label>
                <Select
                  name="food_source"
                  value={editFormData.food_source}
                  onChange={handleInputChange}
                >
                  <option value="VEG">Vegetarian</option>
                  <option value="NON-VEG">Non-Vegetarian</option>
                </Select>
              </FormGroup>
            </ModalBody>
            
            <ModalFooter>
              <CancelButton onClick={handleCloseModal} disabled={isUpdating}>
                {isUpdating ? 'Please Wait...' : 'Cancel'}
              </CancelButton>
              <SaveButton onClick={handleSaveChanges} disabled={isUpdating}>
                {isUpdating ? 'Updating...' : 'Save Changes'}
              </SaveButton>
            </ModalFooter>
          </ModalContent>
        </ModalOverlay>
      )}
    </MainContainer>  
  )
}

export default Menu

const MainContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  overflow-y: auto;
`

const WrapperContainer = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 2rem 4rem;

  @media ${b.mobile}{
    padding: 1rem 1rem 6rem;
  }
`

const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
`

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${b.mobile}{
    width: 100%;
  }
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
`

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 480px;
  max-height: 80vh;
  max-height: 80dvh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2.4rem;
  border-bottom: 1px solid #f4f4f5;
  h2 {
    margin: 0;
    color: #1e1e2d;
    font-size: 1.7rem;
    font-weight: 700;
  }
`

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #71717a;
  transition: all 0.15s;
  min-width: 40px;
  min-height: 40px;
  -webkit-tap-highlight-color: transparent;
  &:hover, &:active {
    background-color: #f4f4f5;
    color: #1e1e2d;
  }
`

const ModalBody = styled.div`
  padding: 2rem 2.4rem;
`

const FormGroup = styled.div`
  margin-bottom: 1.6rem;
`

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: #1e1e2d;
  font-size: 1.3rem;
`

const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e4e4e7;
  border-radius: 10px;
  font-size: 1.3rem;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s;
  &:focus {
    outline: none;
    border-color: #F7707D;
    box-shadow: 0 0 0 3px rgba(247, 112, 125, 0.1);
  }
`

const Textarea = styled.textarea`
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e4e4e7;
  border-radius: 10px;
  font-size: 1.3rem;
  font-family: 'Nunito Sans', sans-serif;
  resize: vertical;
  transition: all 0.2s;
  &:focus {
    outline: none;
    border-color: #F7707D;
    box-shadow: 0 0 0 3px rgba(247, 112, 125, 0.1);
  }
`

const Select = styled.select`
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e4e4e7;
  border-radius: 10px;
  font-size: 1.3rem;
  font-family: 'Nunito Sans', sans-serif;
  background-color: white;
  transition: all 0.2s;
  &:focus {
    outline: none;
    border-color: #F7707D;
    box-shadow: 0 0 0 3px rgba(247, 112, 125, 0.1);
  }
`

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  padding: 1.5rem 2.4rem;
  border-top: 1px solid #f4f4f5;
`

const CancelButton = styled.button`
  padding: 0.8rem 1.6rem;
  border: 1.5px solid #e4e4e7;
  background: white;
  color: #52525b;
  border-radius: 10px;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s;
  &:hover {
    border-color: #d4d4d8;
    background-color: #fafafa;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

const SaveButton = styled.button`
  padding: 0.8rem 1.6rem;
  border: none;
  background: linear-gradient(135deg, #F7707D 0%, #F29173 100%);
  color: white;
  border-radius: 10px;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  font-family: 'Nunito Sans', sans-serif;
  transition: all 0.2s;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(247, 112, 125, 0.35);
  }
  &:disabled {
    background: #d4d4d8;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`


